export default {
  search: 'Pencarian',
  searchPlaceholder: 'No. AWB, No. Pesanan, Nama Pengirim / Penerima',
  dateRange: 'Rentang Tanggal',
  dataNotFound: 'Data tidak ditemukan!',
  tab: {
    all: 'Semua',
    ongoing: 'Diproses',
    unpaid: 'Menunggu Pembayaran',
    completed: 'Selesai',
    complain: 'Complain',
    draft: 'Draf'
  },
  addOrder: 'Tambah Pesanan',
  uploadOrder: 'Unggah Pesanan',
  downloadTemplateOrder: 'Unduh',
  show: 'Menampilkan',
  from: 'dari',
  uploadOrderCard: {
    editButton: 'Ubah',
    deleteButton: 'Hapus'
  },
  draftOrderCard: {
    continueOrder: 'Lanjutkan Pesanan'
  },
  orderCard: {
    orderNumber: 'Nomer Pesanan',
    awbPartner: 'AWB Mitra',
    moreDetail: 'Lebih Rinci',
    sender: 'Nama Pengirim',
    senderAddress: 'Alamat Pengirim',
    detailPickup: 'Detail Pickup',
    receiverName: 'Nama Penerima',
    receiverAddress: 'Alamat Penerima',
    detailShipping: 'Detail Pengiriman',
    weight: 'Berat Barang',
    goodsCategory: 'Jenis Paket',
    price: 'Harga'
  },
  orderDetail: {
    awbPartner: 'AWB Mitra',
    submitComplaint: 'Ajukan Complain',
    continuePayment: 'Lanjutkan Pembayaran',
    weightTypePackage: 'Berat dan Jenis Paket',
    weight: 'Berat Barang',
    type: 'Jenis Paket',
    deliveryService: 'Jasa Pengiriman',
    serviceName: 'Nama Layanan',
    serviceType: 'Tipe Layanan',
    senderInfo: 'Informasi Pengirim',
    senderName: 'Nama Pengirim',
    senderPhone: 'No. HP Pengirim',
    senderAddress: 'Alamat Pengirim',
    pod: 'Alamat info pengirim digunakan kembali untuk pengiriman surat jalan POD.',
    receiverInfo: 'Informasi Penerima',
    receiverName: 'Nama Penerima',
    receiverPhone: 'No. HP Penerima',
    receiverAddress: 'Alamat Penerima',
    packagePhoto: 'Foto Barang',
    photoNotAvailable: 'Foto tidak tersedia',
    priceAdjustment: 'Penyesuaian Harga',
    oldWeight: 'Berat Lama',
    newWeight: 'Berat Baru',
    oldDimension: 'Dimensi Lama',
    newDimension: 'Dimensi Baru',
    oldPrice: 'Harga Lama',
    newPrice: 'Harga Baru',
    markAsPaid: 'Tandai Sudah Dibayar',
    markAsPaidConfirmTitle: 'Konfirmasi Tandai Sudah Dibayar',
    markAsPaidConfirmDesc: 'Apakah Anda yakin ingin menandai penyesuaian harga ini sudah dibayar? Status akan diubah menjadi Pembayaran Sedang Diverifikasi.',
    paymentAccountInfo: 'Informasi Rekening Pembayaran',
    accountName: 'Nama Rekening',
    accountBank: 'Bank',
    accountNumberLabel: 'Nomor Rekening',
    paymentInfo: 'Info Pembayaran',
    status: 'Status',
    paymentType: 'Tipe Pembayaran',
    bank: 'Bank',
    accountNumber: 'No Rekening',
    deliveryStatus: 'Status Pengiriman',
    statusChange: 'Perubahan Status',
    statusDesc: 'Pastikan informasi alamat dan isi paket sesuai dengan ketentuan barang yang telah ditetapkan. perubahan proses tidak bisa di ubah',
    underpaid: 'Kurang Bayar',
    length: 'Panjang',
    width: 'Lebar',
    height: 'Tinggi',
    additionalPrice: 'Penambahan Harga',
    other: 'Lainnya',
    deliveryLabel: 'Label Pengiriman',
    downloadLabelText: 'Apakah anda ingin mendownload label pengiriman?'
  },
  createOrder: {
    stepOne: {
      title: 'Langkah 1',
      desc: 'Data Pengiriman Paket',
      dataNotFound: 'Maaf data tidak ditemukan!',
      senderInfo: 'Info Pengirim',
      senderAddress: 'Alamat Pengirim',
      senderAddressPlaceholder: 'Cari pengirim',
      searchSenderPlaceholder: 'Cari alamat pengirim...',
      detailAddress: 'Detail Alamat',
      mainAddress: 'Alamat Utama',
      addAddress: 'Tambah Alamat',
      selectAddress: 'Pilih Alamat',
      updateAddress: 'Ubah Alamat',
      manualInput: 'Input Manual',
      receiverInfo: 'Info Penerima',
      receiverName: 'Nama Penerima',
      receiverNamePlaceholder: 'Masukan nama penerima',
      receiverPhone: 'No. HP Penerima',
      receiverPhonePlaceholder: 'Masukan nomer hp penerima',
      receiverDistrict: 'Kecamatan / Kelurahan / Kodepos Penerima',
      receiverDistrictPlaceholder: 'Kecamatan / Kelurahan / Kodepos Penerima',
      receiverAddress: 'Alamat Penerima',
      receiverAddressPlaceholder: 'Masukan alamat lengkap penerima (contoh: jln. Merpati No. 35, RT/RW, Kelurahan X, Kecamatan Y, Kota/Kabupaten Z, 12345)',
      serviceType: 'Jenis Layanan & Paket',
      pickupDate: 'Tanggal Pickup',
      pickupTime: 'Waktu Pickup',
      pickupTimePlaceholser: 'Pilih waktu pickup',
      packageType: 'Jenis Paket',
      packageTypePlaceholder: 'Pilih jenis paket',
      packageSize: 'Ukuran Paket',
      pod: 'Ketersediaan logistik akan menyesuaikan dan mendukung pengiriman POD.',
      deliveryService: 'Layanan Pengiriman',
      cancel: 'Batal',
      next: 'Lanjut',
      modal: {
        customPackage: 'Custom Paket',
        weight: 'Berat Paket',
        weightPlaceholder: 'Isi berat paket',
        length: 'Panjang',
        width: 'Lebar',
        height: 'Tinggi',
        cancel: 'Batal',
        submit: 'Submit'
      },
      receiverAddressForm: {
        title: 'Pilih Lokasi Penerima',
        receiverAddress: 'Alamat Penerima',
        receiverAddressPlaceholder: 'Cari penerima',
        cancel: 'Batal',
        save: 'Simpan'
      }
    },
    stepTwo: {
      title: 'Langkah 2',
      desc: 'Data Logistik',
      show: 'Menampilkan',
      unavailableService: 'Layanan saat ini tidak tersedia',
      deliveryService: 'layanan pengiriman',
      deliveryServiceTitle: 'Layanan Pengiriman',
      minimumWeight: 'Minimal berat pengiriman',
      maximumWeight: 'Maksimal berat pengiriman',
      adjustWeight: 'mohon untuk menyesuaikan berat barang.',
      noService: 'Tidak ada layanan pengiriman yang tersedia.',
      insurance: 'Asuransi Pengiriman',
      goodsValue: 'Harga Barang Yang Diasuransikan',
      goodsValuePlaceholder: 'Harga barang',
      insuranceCost: 'Biaya asuransi pengiriman',
      pickupLater: 'Pick up Nanti',
      pickupLaterText: 'Jika melakukan order lebih dari jam 14:00, berpotensi akan di pickup dihari berikutnya',
      senderInformation: 'Informasi Pengirim',
      senderAddress: 'Alamat Pengirim',
      senderDetailAddress: 'Detail',
      receiverInformation: 'Informasi Penerima',
      receiverAddress: 'Alamat Penerima',
      weight: 'Berat Barang',
      packageType: 'Jenis Paket',
      pod: 'Pengiriman surat jalan (POD) akan dikirimkan ke alamat pengirim.',
      back: 'Kembali',
      next: 'Lanjut',
      cutOffNote: 'Pesanan berpotensi dijemput esok hari karena telah melewati batas waktu pemrosesan.'
    },
    stepThree: {
      title: 'Langkah 3',
      desc: 'Konfirmasi',
      detail: 'Rincian',
      shippingDestination: 'Tujuan Pengiriman',
      serviceType: 'Tipe Layanan',
      logistic: 'Logistik',
      goodsCategory: 'Isi Paket',
      weight: 'Berat Pengiriman',
      pickupService: 'Layanan Pickup',
      pickupTime: 'Waktu Pickup',
      pod: 'Pengiriman Surat Jalan (POD)',
      podExist: 'Ada',
      goodsValue: 'Harga barang',
      shippingCost: 'Biaya Pengiriman',
      shippingCostPod: 'Biaya Pengiriman (POD)',
      pickupCost: 'Biaya Pickup',
      shippingCostDiscount: 'Biaya Diskon',
      insuranceCost: 'Biaya Asuransi Pengiriman',
      totalCost: 'Total Harga',
      senderInformation: 'Informasi Pengirim',
      senderAddress: 'Alamat Pengirim',
      podNote: 'Pengiriman surat jalan (POD) akan dikirimkan ke alamat pengirim.',
      receiverInformation: 'Informasi Penerima',
      receiverAddress: 'Alamat Penerima',
      itemWeight: 'Berat Barang',
      details: 'Details',
      back: 'Kembali',
      pay: 'Bayar',
      draft: 'Simpan ke Draft'
    }
  }
}
